import React from "react";
import { SITE } from "@/data/site";

export default function TrustedBy() {
  const items = [...SITE.clients, ...SITE.clients];
  return (
    <section
      data-testid="trusted-by-section"
      className="relative bg-brand-bg border-y border-brand-border py-8 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
        <div className="shrink-0">
          <div className="text-xs uppercase tracking-[0.3em] text-brand-accent">Důvěřují nám</div>
          <div className="mt-1 font-display font-black text-lg lg:text-xl leading-tight">
            Připravujeme vozidla pro
          </div>
        </div>

        <div className="relative flex-1 min-w-0 [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
          <div className="flex w-max gap-12 pr-12 animate-marquee hover:[animation-play-state:paused]" data-testid="trusted-by-marquee">
            {items.map((c, i) => (
              <span
                key={`${c}-${i}`}
                data-testid={i < SITE.clients.length ? `client-${i}` : undefined}
                className="font-display font-black text-xl lg:text-2xl uppercase tracking-tight text-white/45 hover:text-white transition-colors whitespace-nowrap"
              >
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
